// extracted by mini-css-extract-plugin
export default {"heading":"Tj-z","list":"Uj-z"};